// *****************
// MenuConfig = MenuConfig.jsx
// autor: W de Paula / MVinfo
// data: 02/06/24 | 15:56h
// *****************



import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";

import { Howl } from 'howler';
import Swal from 'sweetalert2';

import apiaxios from '../../../../Services/apiaxios';
import handleApiError from '../../../../Services/apiErrorHandler';
// import { encrypt, decrypt } from '../../../../Services/cryptoUtils'; // Importa as funções de criptografia


import SomNotificacao from '../../../../Assets/agendex/agendex-notification.mp3';

import './menuconfig.css';

// function MenuConfig() {
function MenuConfig(props) {
    const [QtNotificacoesAtual, setQtNotificacoesAtual] = useState(0); 
    const [userInteracted, setUserInteracted] = useState(false); // Novo estado para rastrear a interação do usuário
    const id_usuario = props.id_usuario;  
    const navigate = useNavigate();

    // const activeLink = "nav-link active";
    // const inactiveLink = "nav-link text-black";

    // console.log ('id_usuario', id_usuario);
    const handleTrocarCidadeClick = () => {
        localStorage.setItem("buscaCidade", true);
        window.dispatchEvent(new Event('storage'));  // Força a atualização do estado
    };

    useEffect(() => {
        // Função para definir que o usuário interagiu com a página
        const handleUserInteraction = () => {
            setUserInteracted(true);
        };

        // Adicionar eventos de interação do usuário
        window.addEventListener('click', handleUserInteraction);
        window.addEventListener('keydown', handleUserInteraction);

        const fetchNotificacoes = async () => {
            try {
                // console.log ('id_usuario fetchnotificacoes', id_usuario);
                const response = await apiaxios.get(`/Notificacao/Atualiza`, {
                    params: { id_usuario: id_usuario, tp_usuario: 'C' }
                });

                if (response.status === 200) {
                    const data = response.data;
                    // console.log ('status code',response.status);
                    // console.log ('retorno', data.retorno);

                    if (data.retorno !== 'OK') {
                        throw new Error(data.retorno);
                    }

                    const novaQuantidade = data.quantidade;
                    // const encryptedData = localStorage.getItem('QtNotificacoesAnterior');
                    let quantidadeAnterior = 0;
                    quantidadeAnterior = localStorage.getItem('QtNotificacoesAnterior');

                    // if (encryptedData) {
                    //     try {
                    //         const decryptedData = decrypt(encryptedData);
                    //         if (decryptedData.id_usuario === id_usuario) {
                    //             quantidadeAnterior = decryptedData.quantidade;
                    //         }
                    //     } catch (error) {
                    //         console.error('Erro ao descriptografar os dados:', error);
                    //     }
                    // }

                    if (novaQuantidade > QtNotificacoesAtual) {
                        setQtNotificacoesAtual(novaQuantidade);
                        if (userInteracted) {
                            tocarSom();
                            vibrarDispositivo();
                        }
                    } else if (novaQuantidade !== QtNotificacoesAtual) {
                        setQtNotificacoesAtual(novaQuantidade);
                    }

                    // const encryptedQuantidade = encrypt({ id_usuario, quantidade: novaQuantidade });
                    // localStorage.setItem('QtNotificacoesAnterior', encryptedQuantidade);
                    localStorage.setItem('QtNotificacoesAnterior', QtNotificacoesAtual);

                } else {
                    throw new Error("Erro ao carregar notificações");
                }
            } catch (error) {
                // console.error("Erro ao atualizar notificações:", error);
                handleApiError(error);
            }
        };

        // Fetch on component mount
        fetchNotificacoes();

        // Fetch every 15 minutes
        const interval = setInterval(fetchNotificacoes, 15 * 60 * 1000);

        return () => clearInterval(interval);
    }, [id_usuario, QtNotificacoesAtual, userInteracted]);

    const tocarSom = () => {
        const sound = new Howl({
            // src: ['/path/to/sound/file.mp3'],
            src: [SomNotificacao],
            volume: 1.0,
        });
        sound.play();
    };

    const vibrarDispositivo = () => {
        if ('vibrate' in navigator) {
            navigator.vibrate(1000);
        }
    };

    // const iconeSininho = () => {
    //     if (QtNotificacoesAtual > 0) {
    //         return (
    //             <div style={{ position: 'relative' }}>
    //                 <i className="bi bi-bell fs-2" style={{ color: 'yellow' }} />
    //                 <span
    //                     style={{
    //                         position: 'absolute',
    //                         top: '-10px',
    //                         right: '-10px',
    //                         background: 'red',
    //                         color: 'white',
    //                         borderRadius: '50%',
    //                         padding: '5px',
    //                         minWidth: '20px',
    //                         textAlign: 'center'
    //                     }}>
    //                     {QtNotificacoesAtual}
    //                 </span>
    //             </div>
    //         );
    //     } else {
    //         return <i className="bi bi-bell-o fs-2" />;
    //     }
    // };

    const iconeSininho = () => {
        return (
            <div style={{ position: 'relative' }}>
                <i className={`bi ${QtNotificacoesAtual > 0 ? 'bi-bell' : 'bi-bell-o'} fs-2`} style={{ color: QtNotificacoesAtual > 0 ? 'yellow' : 'inherit' }} />
                {QtNotificacoesAtual > 0 && (
                    <span
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            padding: '5px',
                            minWidth: '20px',
                            textAlign: 'center'
                        }}>
                        {QtNotificacoesAtual}
                    </span>
                )}
            </div>
        );
    };

    const handleLogoutClick = () => {
        Swal.fire({
            title: 'Confirma Logof?',
            text: 'Ao fazer logof (sair de sua conta) você será desconectado desta seção. Será necessário fazer Login novamente para ter acesso ao Agendex Web',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, encerrar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                LogoutComponent();
                navigate('/app/login/cliente');
            }
        });
    };

    function LogoutComponent() {
        localStorage.removeItem("tokenlg");
        localStorage.removeItem("tokenacw");
        localStorage.removeItem("tokenasw");
        localStorage.removeItem("id_categoria");
        localStorage.removeItem("buscaCidade");
    };

    const handleSobreClick = () => {

        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: true,
            // timer: 3000,
            // timerProgressBar: true,
            icon: 'info',
            title: 'Agendex® Web. Version 1.0.26. Copyright © 2021-2025 .',
            text: '(c)Agendex. All-in-one. Minha Agenda. Agenda Profissional.  Microvolution Informática, by WMX Group. All Rights Reserved. Todos os Direitos Reservados. (30/12/24)'
        });

        // Swal.fire({
        //     title: 'Sobre o Agendex Cliente Web',
        //     text: 'Ao fazer logof (sair de sua conta) você será desconectado desta seção. Será necessário fazer Login novamente para ter acesso ao Agendex Web',
        //     icon: 'info',
        //     // showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     // cancelButtonColor: '#d33',
        //     confirmButtonText: 'OK!',
        //     // cancelButtonText: 'Cancelar'
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         LogoutComponent();
        //         navigate('/app/login/cliente');
        //     }
        // });
    };
    
    return (
        <div className="container-menu-config">
            <div className="title-menu-config">
                {/* <Link to="/app/cliente/notificacoes" className="" aria-current="page">
                    <i className="bi bi-bell fs-2"></i>
                </Link> */}
                <Link to="/app/cliente/notificacoes" className="" aria-current="page">
                    {iconeSininho()}
                </Link>
                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="bi bi-three-dots-vertical fs-5"></i>
                    </button>
                    <ul className="dropdown-menu">
                        {/* *********** sub menu trocar cidade temporariamente ************** */}
                        <li>
                            <button className="dropdown-item dropdown-item-short" type="button" onClick={handleTrocarCidadeClick}>
                                Trocar Cidade
                            </button>
                            <button className="dropdown-item dropdown-item-full" type="button" onClick={handleTrocarCidadeClick}>
                                Trocar Cidade Temporariamente
                            </button>
                        </li>
                        {/* *********** sub menu trocar cidade temporariamente ************** */}
                        
                        <li><button className="dropdown-item disabled" type="button">Tamanho Fonte</button></li>
                        <li><button className="dropdown-item disabled" type="button">Tema Escuro</button></li>

                        {/* *********** sub menu notificações internas ************** */}
                        <li>
                            {/* ******* tablet, NB, PC ********* */}
                            <Link to="/app/cliente/config/notificacoes" className={`dropdown-item dropdown-item-full props.page === "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-bell-slash"></i> <span className="ms-1 d-sm-inline menu-title">Notificações Internas</span>
                            </Link>
                            {/* ******** celular ********* */}
                            <Link to="/app/cliente/config/notificacoes" className={`dropdown-item dropdown-item-short props.page = "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-bell-slash"></i> <span className="ms-1 d-sm-inline">Notificações</span>
                            </Link>
                        </li>
                        {/* *********** sub menu notificações internas ************** */}

                        {/* *********** sub menu fale conosco ************** */}
                        <li>
                            {/* ******* tablet, NB, PC ********* */}
                            <Link to="/app/cliente/config/faleconosco" className={`dropdown-item dropdown-item-full props.page === "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-chat-dots"></i> <span className="ms-1 d-sm-inline menu-title">Fale Conosco</span>
                            </Link>
                            {/* ******** celular ********* */}
                            <Link to="/app/cliente/config/faleconosco" className={`dropdown-item dropdown-item-short props.page = "notificacoesinternas"`} aria-current="page">
                                <i className="bi bi-chat-dots"></i> <span className="ms-1 d-sm-inline">Fale Conosco</span>
                            </Link>
                        </li>

                        {/* <Link to="/app/cliente/config/faleconosco" className={props.page === "faleconosco" ? activeLink : inactiveLink}>
                                    <i className="bi bi-chat-dots"></i>
                                    <span className="ms-1 d-none d-sm-inline">Fale Conosco</span>
                                </Link> */}
                        {/* *********** sub menu fale conosco ************** */}

                        {/* *********** sub menu Sobre o Agendex ************** */}
                        <li>
                            {/* ******* tablet, NB, PC ********* */}
                            <button 
                                className="dropdown-item dropdown-item-full" type="button" onClick={handleSobreClick}>
                                <i className="bi bi-info-circle-fill"></i> <span className="ms-1 d-sm-inline menu-title">Sobre o Agendex Cliente Web</span>
                            </button>
                            {/* ******** celular ********* */}
                            <button 
                                className="dropdown-item dropdown-item-short" type="button" onClick={handleSobreClick}>
                                <i className="bi bi-info-circle"></i> <span className="ms-1 d-sm-inline">Sobre</span>
                            </button>
                        </li>
                        {/* *********** sub menu Sobre o Agendex ************** */}

                        <hr />
                        <li>
                            <button 
                                className="dropdown-item dropdown-item-full" type="button" onClick={handleLogoutClick}>
                                <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline menu-title">Sair da Conta(Logout)</span>
                            </button>

                            <button 
                                className="dropdown-item dropdown-item-short" type="button" onClick={handleLogoutClick}>
                                <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline">Logout</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MenuConfig;
